import { useCallback } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { ReactComponent as GgMenuIcon } from '../../../assets/images/common/icons/sidebarMenu/GgMenu.svg'
import { fetchGgMenuData } from '../../../actions/ggMenuActions'
import styles from '../../../assets/styles/components/common/GgMenuButton.module.scss'
import classNames from 'classnames'

const GgMenuButton = ({ className }) => {
  const { t } = useTranslation()

  const handleClick = useCallback(async () => {
    try {
      const response = await fetchGgMenuData()
      window.GgMenuData = response.data
      if (window.GgMenu) {
        window.GgMenu.showMenu(window.GgMenuData)

        const ggMenuEl = document.querySelector('#gg_menu')
        if (ggMenuEl) {
          ggMenuEl.style.zIndex = '1000'
        }
      }
    } catch (err) {
      console.error('Failed to open GG menu', err)
    }
  }, [])

  return (
    <button
      className={classNames('d-flex justify-content-center align-items-center', styles.ggMenuButton, className)}
      onClick={handleClick}
      aria-label={t('common.ggMenuButton.ariaLabel')}
    >
      <GgMenuIcon />
    </button>
  )
}

GgMenuButton.propTypes = {
  className: PropTypes.string,
}

export default GgMenuButton
